export default __webpack_public_path__ + "static/media/icon-down.338b1db4.svg";